import React, { useContext } from 'react';
import { Chip, Grid } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { TcsmStates } from '../../root/tcsm-model';
import { FilterPill, SearchAppContext } from '../models/search-models';
import { SearchProps } from '../../pages/arc/models/arc-epi-props';
import { removeFilterByApp, resetSearchByApp, setFilterPills } from '../slices/backend-search-slice';
import { buttonStyles } from '../../global/constants/theme/styles/components/buttonstyles';

export function FilterPills() {
    const app = useContext(SearchAppContext);
    const dispatch = useDispatch();
    const searchSettings = useSelector<TcsmStates, SearchProps>(state => state?.epiProps?.searchSettingsState?.epiContent);
    const pills = useSelector<TcsmStates, FilterPill[]>(state => state?.backendSearchStates[app].filterPills);
    const buttonClasses = buttonStyles();

    if (pills?.length === 0) {
        return null;
    }

    const onResetFilter = () => {
        dispatch(resetSearchByApp(app));
    };

    const removePill = (pill: FilterPill) => {
        dispatch(removeFilterByApp({ type: pill?.type, value: pill.rawValue }, app));
        dispatch(setFilterPills(pills?.filter(p => p?.rawValue !== pill.rawValue || p?.type !== pill?.type), app));
    };

    return (
        <div className='filters-chips'>
            <Grid className='filters-chips-header' item sm={12} container justifyContent='space-between' alignItems='baseline'>
                <h4>{searchSettings?.selectedFilterLabel}</h4>
                <button className={buttonClasses.linkButton} type='button' onClick={onResetFilter} >{searchSettings?.clearAllText}</button>
            </Grid>

            {
                pills?.map(p =>

                    <div className='filters-chips-item' key={`${p?.rawValue}-${p?.type}`}>
                        <Chip
                            variant='outlined'
                            label={<p>{p?.label}: <strong>{p?.display || p?.value}</strong></p>}
                            onDelete={() => removePill(p)}
                        />
                    </div>)
            }
        </div>
    );
}


